import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

type TimeUnit = moment.DurationInputArg2;

interface RelativeDurationRule {
    breakpoint: TimeUnit | null;
    unit: TimeUnit | null;
    label: string;
}

const DURATION_FORMATTING_RULES: RelativeDurationRule[] = [
    { breakpoint: 'minute', unit: null,     label: 's' },
    { breakpoint: 'hour',   unit: 'minute', label: 'm' },
    { breakpoint: 'day',    unit: 'hour',   label: 'h' },
    { breakpoint: 'week',   unit: 'day',    label: 'd' },
    { breakpoint: 'month',  unit: 'week',   label: 'w' },
    { breakpoint: 'year',   unit: 'month',  label: 'mo' },
    { breakpoint: null,     unit: 'year',   label: 'y' },
];

@Pipe({
    name: 'formatDuration',
    standalone: false
})
export class FormatDurationPipe implements PipeTransform {
    transform(value: number | null | undefined): string {
        if (!value || !Number.isFinite(value)) {
            return '';
        }

        for (const rule of DURATION_FORMATTING_RULES) {
            if (rule.breakpoint && value >= getDurationInSeconds(rule.breakpoint)) {
                continue;
            }

            return rule.unit
                ? `${Math.floor(value / getDurationInSeconds(rule.unit))}${rule.label}`
                : rule.label;
        }

        return '';
    }
}

function getDurationInSeconds(unit: TimeUnit): number {
    return moment.duration(1, unit).asSeconds();
}
